import { formatMoneyWhole } from '@app/shared'

export function CampaignAbout({
  label,
  period,
  tagline,
  appeal,
  goalCents,
  pledgedCents,
}: {
  label: string
  period: string | null
  tagline: string | null
  appeal: string | null
  goalCents: number | null
  pledgedCents: number | null
}) {
  /* Capped at 100 because a drive that beat its goal is a full bar, and
     floored so a drive short of its goal never draws as reached. */
  const pctPledged =
    goalCents && goalCents > 0
      ? Math.min(100, Math.floor(((pledgedCents ?? 0) / goalCents) * 100))
      : 0

  return (
    <div className="donate__about">
      <div className="give__head-title">
        <h1 className="give__title">{label}</h1>
        {period ? <p className="donate__sub">{period}</p> : null}
      </div>

      {/* The drive's one line, under its name: a fund named by a code says
          whom it helps here and nowhere else. */}
      {tagline ? <p className="donate__tagline">{tagline}</p> : null}

      {/* The appeal is text, set with the breaks it was typed with. */}
      {appeal ? <p className="donate__appeal">{appeal}</p> : null}

      {goalCents !== null && pledgedCents !== null && (
        <div className="donate__progress">
          <div
            className="donate__track"
            role="progressbar"
            aria-valuenow={pctPledged}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={`${formatMoneyWhole(pledgedCents)} pledged of ${formatMoneyWhole(goalCents, 'up')}`}
          >
            <div className="donate__fill" style={{ width: `${pctPledged}%` }} />
          </div>
          <p className="donate__pledged">
            <span className="donate__pledged-figure">
              {formatMoneyWhole(pledgedCents)}
            </span>{' '}
            pledged of{' '}
            <span className="donate__goal-figure">
              {formatMoneyWhole(goalCents, 'up')}
            </span>
          </p>
        </div>
      )}
    </div>
  )
}
